import { render, staticRenderFns } from "./NewReport.vue?vue&type=template&id=645c44ce&scoped=true&"
import script from "./NewReport.vue?vue&type=script&lang=js&"
export * from "./NewReport.vue?vue&type=script&lang=js&"
import style0 from "./NewReport.vue?vue&type=style&index=0&id=645c44ce&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645c44ce",
  null
  
)

export default component.exports